import { render, staticRenderFns } from "./cms-product-item-table.vue?vue&type=template&id=178b0dca&"
import script from "./cms-product-item-table.vue?vue&type=script&lang=js&"
export * from "./cms-product-item-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports